import { GetCurrentLogin } from "../account/AccountStore";
import { CoerceToArrayBuffer } from "./Helpers";
import axios from "./HttpClient";

export const Subscribe = (key) => {
    navigator.serviceWorker.register("/sw.js").then(async (reg) => {
        await reg.update();
        if (Notification.permission === "granted") {
            doSubscription(reg, key);
            // } else if (Notification.permission === "denied") {
        } else {
            askPermission().then((permission) => {
                if (permission === "granted") {
                    doSubscription(reg, key);
                }
            });
        }
    });
};

export const Notify = (message: { key: string; body: string; title: string }) => {
    axios.post(`/api/PushNotifications/Notify`, message).then((response) => {});
};

const doSubscription = (serviceWorkerRegistration: ServiceWorkerRegistration, key: string) => {
    serviceWorkerRegistration.pushManager.getSubscription().then(function (sub) {
        if (sub === null) {
            serviceWorkerRegistration.pushManager
                .subscribe({
                    userVisibleOnly: true,
                    // @ts-ignore
                    applicationServerKey: window.vapidKey,
                })
                .then(function (sub) {
                    UpdateSubscription(sub, key);
                })
                .catch(console.error);
        } else {
            UpdateSubscription(sub, key);
        }
    });
};

const askPermission = (): Promise<"granted" | "denied" | "default"> => {
    return new Promise(function (resolve, reject) {
        const permissionResult = Notification.requestPermission(function (result) {
            resolve(result);
        });

        if (permissionResult) {
            permissionResult.then(resolve, reject);
        }
    });
};

const UpdateSubscription = async (pushSubscription: PushSubscription, key: string) => {
    let account = await GetCurrentLogin();
    let req = { userID: account.id, key, pushSubscription: pushSubscription.toJSON() };
    req.pushSubscription.expirationTime = req.pushSubscription.expirationTime || 0;
    axios.post("/api/PushNotifications/Subscribe", req).then((response) => {});
};
